import FontFaceObserver from 'fontfaceobserver';
import fd from './lib/promise-fastdom';
import {trigger} from './lib/events';
import ready from './lib/ready';

ready().then(function init() {
    window.webfonts && Promise.all(window.webfonts.map(function (font) {
        return new FontFaceObserver(font.family, font.opts).load();
    }))
        .then(function (fonts) {
            fonts.forEach(function (font) {
                // eslint-disable-next-line no-console
                console.debug('Font loaded: %s', font.family, font.weight, font.style);
            });
            return fd.mutate(function () {
                document.documentElement.classList.add('fonts-on');
                trigger.call(document, 'font-loaded');
                const ltc = new Date(new Date().setFullYear(new Date().getFullYear() + 1));
                document.cookie = 'fonts_loaded=true; expires=' + ltc + '; path=/;';
            });
        })
        .catch(function (e) {
            console.warn('Fonts loading timeout, web fonts canceled', e);
        })
    ;
});